import { AuthCompany } from 'src/models';

const ELIGIBLE_ROLES = ['owner', 'admin', 'manager'];

/**
 * Effective AI Connections (MCP) access for the signed-in user.
 * Company mode "on" (or missing) grants access to eligible roles.
 * Mode "user" uses the stored per-user flag; missing is treated as enabled
 * so a lagging BE formalize does not hide the nav for every manager.
 */
export function canUseAiConnections(company: AuthCompany | undefined | null): boolean {
  if (!company || !ELIGIBLE_ROLES.includes(company.role)) {
    return false;
  }

  const mode = company.companySettings?.aiConnectionsTracking ?? 'on';
  if (mode === 'off') {
    return false;
  }
  if (mode === 'user') {
    return company.userSettings?.enableAiConnections !== false;
  }
  return true;
}

/** API key creation and cross-user revoke: owners and admins only. */
export function canManageAiApiKeys(company: AuthCompany | undefined | null): boolean {
  return ['owner', 'admin'].includes(company?.role ?? '');
}
